import { Colors, FlexBox, MEDIA, useBreakpoint } from '@brg/ui';
import { BTagsGrid } from 'core/components';
import React, { FC, ReactElement, useEffect, useMemo, useState } from 'react';
import styled, { useTheme, css } from 'styled-components';
import { LayoutConst } from 'core';
import { Lang, Project, Competition } from '@brg/api';
import ProjectHeader from '../components/ProjectHeader';
import TeamHeader from 'shared/pages/teams/components/TeamHeader';
import { AppTester } from "../../../../supporting";
import { useProfile } from '@brg/auth';
import { ANCHOR_TYPE, IAddProjectCoverContent } from 'shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType';
import { useTranslation } from 'react-i18next';
import { el } from 'date-fns/locale';
import { useProject } from 'shared/hooks/api/useProject';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { ProjectAnchorNavigate as Navigation } from '../components/ProjectAnchorNavigate';
import { InPartCompetition } from '../components/InPartCompetition';
import { ButtonsWrapper } from '../styles';
import { useSelector } from 'react-redux';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import tinycolor from 'tinycolor2';
import { useHistory } from 'react-router-dom';

const Wrap = styled(FlexBox)<{ visible?: boolean, isPreview?: boolean, disableOffset?: boolean }>`
    width: 100%;
    display: ${({ visible }) => visible ? 'flex' : 'none'};
    max-width: 1152px;
    margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '32px auto 16px auto'};
    flex-flow: column;
    background-color: transparent;

    //padding: 0 6px 0 48px;

    ${({ isPreview }) => isPreview ? css`
        .approval-dialog-wrap {
            display: none;
        }
    ` : null};

    #tags_container {
        width: 100%;
        max-width: 1152px !important;
    }

    .ps-bottom-wrap {
        flex-flow: column;
        align-items: flex-start;
    }

    div:has(.competition-send) {
        margin-bottom: 0;
    }

    .buttons-wrapper > div {
        &:not(:last-child) {
            margin-right: 16px;
            margin-bottom: 16px !important;
        }
        margin-bottom: 16px !important;
        // svg path {
        //   fill: rgba(0,0,0,0.47);
        // }
        padding: 0;
        order: 0;
      
        @media(max-width: ${LayoutConst.screen.s -1 }px) {
            &:not(:last-child) {
                margin-right: 8px;
            }
        }
      }
    
      .LikesButtonWrapper, .ViewsCountWrapper {
        max-width: fit-content !important;
      }
    
      .likes-icon-wrapper {
        flex-direction: row !important;
        place-items: center;
        display: flex;
    
        @media(max-width: ${LayoutConst.screen.sm}px) {
            flex-direction: column !important;
            // padding-top: 8px;
        }
      }
    
      .likes-icon-wrapper > span {
        margin-left: 8px;
        font-size: 11px;
        line-height: 11px;
        margin-top: 4px;
        // color: rgba(0,0,0,0.47);
    
        @media(max-width: ${LayoutConst.screen.sm}px) {
          margin: 0;
          margin-top: 4px;
        }
      }
    
      .count-icon-wrapper {
        place-items: center;
        display: flex;
        flex-direction: row !important;
        @media(max-width: ${LayoutConst.screen.sm}px) {
            flex-direction: column !important;
            // padding-top: 8px;
        }
      }

    //   .project-tools-send svg path {
    //     fill: rgba(0,0,0,0.47) !important;
    //   }

    //   .project-tools-send svg:hover path {
    //     fill: ${Colors.galBlack100} !important;
    //   } 
    
      .count-icon-wrapper span {
        margin-left: 8px;
        line-height: 11px;
        margin-top: 4px;
        // color: rgba(0,0,0,0.47);
        @media(max-width: ${LayoutConst.screen.sm}px) {
            margin: 0;
            margin-top: 4px;
        }
      }
    
      .ps-action-btn {
        padding: 0 !important;
      }
      .ps-action-moder-btn {
        padding: 0;
      }


      .approval-dialog-wrap {
        margin-left: 0;
        margin-top: 40px;
        max-width: 100%;
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        //padding: 0 36px;
        max-width: 888px;

        .approval-dialog-wrap {
            margin-left: 0;
            margin-top: 40px;
            max-width: 432px;
        }
      }

      @media(max-width: ${LayoutConst.screen.l}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '48px auto 0'};
        padding-bottom: 8px;
      }

      @media(max-width: ${LayoutConst.screen.md}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '32px auto 0 auto'};
        padding: 0 24px 16px;
      }

      @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '24px auto 0'};
        padding: 0 10px;

        .ps-action-btn {
            margin-left: 0 !important;
        }

        .likes-icon-wrapper {
            padding-bottom: 0px;
            column-gap: 4px;
            flex-direction: row !important;
            place-items: center;
        }

        .likes-count-text {
            margin-left: 0 !important;
        }

        .ViewsCountWrapper {
            padding-top: 0px !important;
        }

        .count-icon-wrapper {
            column-gap: 4px;
            flex-direction: row !important;
        }

        .view-count-text {
            margin-left: 0 !important;
        }

        .curators-item {
            // margin-left: 8px;
            margin-right: 0 !important;
        }

        .competition-send {
            margin-right: 0;
            margin-left: 0;
        }

        .approval-dialog-wrap {
            margin-top: 24px;
        }

        .buttons-wrapper {
            flex-direction: row;

            .ps-action-btn , .ps-action-moder-btn{
                margin-right: 8px;
            }

            .likes-icon-wrapper {
                place-items: center;
            }
        }
      }
    
`;

export const AdditionalTitle = styled.div<{color?: string, isMobile?: boolean, mobileColor?: string}>`
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    color: ${({ theme, color, isMobile }) => (color && !isMobile) ? color : theme.projectView.lGTitleColorMobile};
    margin-bottom: 8px;


    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 34px;
    line-height: 41px;
    }
    
    @media ${MEDIA.MOBILE} {
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 4px;
    ${({mobileColor}) => mobileColor && `color: ${mobileColor};`}
    }
`;

export const AdditionalSubtitle = styled.div<{color?: string, isMobile?: boolean, mobileColor?: string}>`

    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    color: ${({ theme, color, isMobile }) => (color && !isMobile) ? color : theme.projectView.lGTitleColorMobile};
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }
    
    @media ${MEDIA.MOBILE} {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 40px;
        ${({mobileColor}) => mobileColor && `color: ${mobileColor};`}
    }
`;


export const AdditionalButton = styled(FlexBox)<{ color?: string, bgColor?: string }>`
    border-radius: 3px;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: ${({ theme, color }) => color || theme.projectView.titleColor};
    background-color: ${({ bgColor }) => bgColor};
    min-width: 187px;
    padding: 12px 48px;
    width: max-content;
    justify-content: center;

    a {
        text-align: center;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        margin-bottom: 24px;
        height: 40px;
        align-items: center;
    }

`;

const TagsWrapper = styled(FlexBox)<{ isAdditionalContent?: boolean }>`

    ${({ isAdditionalContent }) => isAdditionalContent && css`
        margin-top: 56px;
    `};
    margin-bottom: 32px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-bottom: 48px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: 24px;
    }
`;

const TitleWrapper = styled(FlexBox)<{ hseFonts?: boolean }>`
    font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
    font-weight: ${({ hseFonts }) => hseFonts ? 400 : 600};
    
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-bottom: 24px;

    }
`;

const HeaderWrapper = styled(FlexBox)`
    .ProjectHeaderRoot {
        padding-left: 0;
    }
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        .ProjectHeaderRoot {
            margin-bottom: 12px;
        }
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        .ProjectHeaderRoot {
            margin-bottom: 8px;
        }
    }
`;

const TagsList = styled(BTagsGrid)<{ isWideEditor?: boolean }>`

    max-height: ${p => p.scroll ? '92px' : 'none'} !important;
  
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-height: ${p => p.scroll ? (p.isWideEditor ? '81px' : '83px') : 'none'} !important;
    }

    @media(max-width: 940px) {
        max-height: ${p => p.scroll ? '72px' : 'none'} !important;
    }

    @media(max-width: 743px) {
        max-height: ${p => p.scroll ? '115px' : 'none'} !important;
    }

`;

const Wrapper = styled.div`
    width: 100%;
    padding-bottom: 40px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 24px;

    @media ${MEDIA.LAPTOP}
        gap: 0 24px;
    }
  
    @media ${MEDIA.MOBILE} {
        grid-template-columns: repeat(1, 1fr);
        gap: 0 0;
    }
`;

const AnchorText = styled.div`
    font-family: Inter;
    letter-spacing: -0.4px;
    margin-right: 8px;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

const AnchorContainer = styled<any>(FlexBox)`
    width: 100%;
    justify-content: space-between;
    place-items: center;
    border-top: 1px solid ${(p) => (p?.color)};
    padding: 16px 0;
    cursor: pointer;

    &:nth-last-child(-n + 2) {
        border-bottom: 1px solid ${(p) => (p?.color)};
    }

    @media ${MEDIA.MOBILE} {
        &:nth-last-child(-n + 2) {
            border-bottom: none;
        }

        &:last-child {
            border-bottom: 1px solid ${(p) => (p?.color)};
        }
    }

    ${AnchorText} {
        color: ${(p) => (p?.color)};
    }

    svg path {
        fill: ${(p) => (p?.color)};
    }
`;


interface IPresentationBlock {
    project?: Project;
    anchors?: any[];
    title?: ReactElement;
    bottom?: ReactElement;
    mobileBottom?: ReactElement;
    tags?: ReactElement[] | ReactElement;
    dialog?: ReactElement;
    isPreview?: boolean;
    isOutsideText?: boolean;
    titleColor?: string;
    subtitleColor?: string;
    additionalContent?: IAddProjectCoverContent;
    isModer?: boolean;
    competitionsParticipant?: Competition[];
    competitionsWinner?: Competition[];
    competitionFynalist?: Competition[];
}

export const PSpresentationBlock: FC<IPresentationBlock> = ({ 
    project,
    anchors, 
    title, 
    tags, 
    bottom, 
    mobileBottom, 
    dialog, 
    isPreview, 
    isOutsideText,
    subtitleColor, 
    titleColor,
    isModer,
    competitionsParticipant = [],
    competitionsWinner = [],
    competitionFynalist = []
}) => {
    const profile = useProfile();
    const { t, i18n: {language}} = useTranslation();
    const [collapseTags, setCollapseTags] = useState(false);
    const isTeam = useMemo(() => (project && !!project?.teamId), [project]);
    const isTablet = useBreakpoint(LayoutConst.screen.l)
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isProHSE = AppTester.isProHSE();
    const history = useHistory()
    const [time, setTime] = useState(Date.now());
    //@ts-ignore
    const [projectSource, isProjectLoading, projectError] = useProject(project?.replaceLongreadId, language, project?.replaceLongreadId + time);
    //@ts-ignore
    const isTeamHasLongreadCover = !!project?.longreadType
    //@ts-ignore
    const additionalContent = useMemo(() => isTeamHasLongreadCover ? projectSource?.additionalContent : project?.additionalContent , [project, isProjectLoading, projectSource]) as IAddProjectCoverContent | undefined

    const theme = useTheme()
    const { anchorLinks } = useSelector(HseContextSelector) || {};
    const visibleTextColor = tinycolor.mostReadable(theme?.app?.backgroundColor, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
    
    const teamLgTitleVisibleColor = tinycolor.mostReadable(project?.additionalInfo.color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
    
    // @ts-ignore
    const isLMS = useMemo(() => project?.moderationType === ModerationType.LMS, [project?.moderationType])

    // const maxTagHeight = (isMac13 || smHeight) ? 94 : 94;
    const maxTagHeight = isProHSE ? 96 : 94;

    useEffect(() => {
        const tagsContainer: HTMLElement | null = document.querySelector('#tags_container');
        if (tagsContainer) {
          if (tagsContainer?.offsetHeight > maxTagHeight) {
            setCollapseTags(true);
          }
        }
    }, [maxTagHeight])

    const hasAdditionalContent = useMemo(
        //@ts-ignore
        () => additionalContent && Object.values(additionalContent)?.some((i) => i?.text !== ''), [additionalContent]);

    const navgationVisible = useMemo(() => {
        if (additionalContent) {
            const content = additionalContent as IAddProjectCoverContent
            return !!content?.anchors?.anchorVisible && content?.anchors?.anchorType === ANCHOR_TYPE.popup
        }
        return undefined
    }, [project, hasAdditionalContent])

    const Layout = useMemo(() => {

        // if (!isOutsideText) return null;

        if (!!hasAdditionalContent) {
            const { title, subtitle, button, anchors } = additionalContent;

            return (
                <FlexBox style={{ position: 'relative' }} direction='column' directionMobile='column'>
                    {title.visible && (isOutsideText || is743) && (
                        <FlexBox direction='column' directionMobile='column'>
                            <AdditionalTitle mobileColor={isTeam? teamLgTitleVisibleColor : undefined} color={titleColor} isMobile={is743}>{Lang(title.text, language)}</AdditionalTitle>
                            {!!Lang(subtitle.text, language)?.length && <AdditionalSubtitle mobileColor={isTeam? teamLgTitleVisibleColor : undefined} color={subtitleColor} isMobile={is743}>{Lang(subtitle.text, language)}</AdditionalSubtitle>}
                        </FlexBox>
                    )}
                    {is743 && !!anchorLinks?.length && <Wrapper>
                        <Grid>
                            {anchorLinks?.map(({anchorText, postId}) => {
                                return (
                                    <AnchorContainer key={`anchor ${postId}`} color={visibleTextColor} onClick={() => history.push(`#${postId}`)}>
                                        <AnchorText>{anchorText}</AnchorText>
                                        <div>
                                            <svg
                                                width='13'
                                                height='23'
                                                viewBox="0 0 13 23"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.5 0V15.75H10.1895L6.69653 12.2571C6.40386 11.9642 6.40371 11.4894 6.69653 11.1965C6.98935 10.9037 7.46417 10.9039 7.75708 11.1965L12.5303 15.9697C12.8232 16.2626 12.8232 16.7374 12.5303 17.0303L7.75708 21.8035C7.46417 22.0961 6.98935 22.0963 6.69653 21.8035C6.40371 21.5106 6.40386 21.0358 6.69653 20.7429L10.1895 17.25H0V0H1.5Z"
                                                    fill="#151514"
                                                />
                                            </svg>
                                        </div>
                                    </AnchorContainer>
                                )
                            })}
                        </Grid>
                    </Wrapper>}
                    {button?.visible && (isOutsideText || is743) && (
                        <a href={button.href} target={'_SELF'}>
                            <AdditionalButton color={button.color} bgColor={button.bgColor}>{Lang(button.text, language)}</AdditionalButton>
                        </a>
                    )}

                    {tags && (Array.isArray(tags)? tags.length > 0 : true) && !isLMS && (
                        <TagsWrapper width={'100%'} isAdditionalContent={((title.visible && !!Lang(subtitle.text, language)?.length) || button.visible) && isOutsideText}>
                            <BTagsGridNew id="tags_container" scrollMode="all">
                                {tags}
                            </BTagsGridNew>
                        </TagsWrapper>
                    )}
                    {bottom && !is743 && (
                        <FlexBox>
                           {/* {navgationVisible && <Navigation anchors={anchors} />} */}
                            {bottom}
                        </FlexBox>
                    )}
                    {is743 && mobileBottom && (
                        <FlexBox offsetBottomMobile={!profile ? 0 : isModer? 48 : 14}>
                            {mobileBottom}
                        </FlexBox>
                    )}
                    {dialog && (
                        <FlexBox width={'100%'}>
                            {dialog}
                        </FlexBox>
                    )}
                </FlexBox>
            )

        } else {
            return (
                <>
                    {title && (
                        <TitleWrapper>
                            {title}
                        </TitleWrapper>
                    )}
                    {tags && !isLMS && (
                        <TagsWrapper width={'100%'}>
                            <BTagsGridNew id="tags_container" scrollMode="all">
                                {tags}
                            </BTagsGridNew>
                        </TagsWrapper>
                    )}
                    {bottom && !is743 && (
                        <FlexBox width={'100%'} offsetBottom={isTablet? 0 : 48} offsetBottomMobile={isTablet? 0 : 48}>
                            {bottom}
                        </FlexBox>
                    )}
                    {is743 && (!!mobileBottom || !!anchorLinks?.length) && (
                        <FlexBox offsetBottomMobile={!profile ? 0 : 48}>
                            <Wrapper>
                                <Grid>
                                    {anchorLinks?.map(({anchorTest: text, postId: id}) => {
                                        return (
                                            <AnchorContainer key={`anchor ${id}`} color={visibleTextColor} onClick={() => history.push(`#${id}`)}>
                                                <AnchorText>{text}</AnchorText>
                                                <div>
                                                    <svg
                                                        width='13'
                                                        height='23'
                                                        viewBox="0 0 13 23"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M1.5 0V15.75H10.1895L6.69653 12.2571C6.40386 11.9642 6.40371 11.4894 6.69653 11.1965C6.98935 10.9037 7.46417 10.9039 7.75708 11.1965L12.5303 15.9697C12.8232 16.2626 12.8232 16.7374 12.5303 17.0303L7.75708 21.8035C7.46417 22.0961 6.98935 22.0963 6.69653 21.8035C6.40371 21.5106 6.40386 21.0358 6.69653 20.7429L10.1895 17.25H0V0H1.5Z"
                                                            fill="#151514"
                                                        />
                                                    </svg>
                                                </div>
                                            </AnchorContainer>
                                        )
                                    })}
                                </Grid>
                            </Wrapper>
                            {mobileBottom}
                        </FlexBox>
                    )}
                    {dialog && (
                        <FlexBox width={'100%'}>
                            {dialog}
                        </FlexBox>
                    )}
                </>
            )
        }

    } , [hasAdditionalContent, anchors, is743, additionalContent, language, bottom, dialog, collapseTags, is743,  isProHSE, isTablet, title, mobileBottom, profile, isOutsideText, tags])

    const disableOffset = useMemo(() => {
        const hasTitle  = !!hasAdditionalContent && Lang(additionalContent?.title.text, language)?.length > 0
        const hasSubtitle = !!hasAdditionalContent && Lang(additionalContent?.subtitle.text, language)?.length > 0
        const textVisible = (hasTitle || hasSubtitle) && (isOutsideText || is743)

        return !mobileBottom && !dialog && !bottom && (!!tags && isLMS) && !title && !textVisible 
    } , [mobileBottom, dialog, bottom, tags, title, additionalContent, isOutsideText])

    if (!project) {
        return null;
    }

    return (
        isLMS ? (
            <Wrap disableOffset={disableOffset} visible={true} isPreview={isPreview}>
                {Layout}
            </Wrap>
        ) : (
            <Wrap disableOffset={disableOffset} visible={!isTeam || (isTeam && is743)} isPreview={isPreview}>
                <HeaderWrapper>
                    {isTeam ? (
                        //@ts-ignore
                        <>{is743? undefined : <TeamHeader team={project} />}</>
                    ) : (
                        <ProjectHeader project={project} isProjectPage={true} />
                    )}
                </HeaderWrapper>
                {Layout}
                <InPartCompetition
                  competitionsParticipant={competitionsParticipant}
                  competitionsWinner={competitionsWinner}
                  competitionFynalist={competitionFynalist}
                  isMaxWidth
                />
            </Wrap>
        )
    );
}import { Colors, FlexBox, MEDIA, useBreakpoint } from '@brg/ui';
import { BTagsGrid } from 'core/components';
import React, { FC, ReactElement, useEffect, useMemo, useState } from 'react';
import styled, { useTheme, css } from 'styled-components';
import { LayoutConst } from 'core';
import { Lang, Project, Competition } from '@brg/api';
import ProjectHeader from '../components/ProjectHeader';
import TeamHeader from 'shared/pages/teams/components/TeamHeader';
import { AppTester } from "../../../../supporting";
import { useProfile } from '@brg/auth';
import { ANCHOR_TYPE, IAddProjectCoverContent } from 'shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType';
import { useTranslation } from 'react-i18next';
import { el } from 'date-fns/locale';
import { useProject } from 'shared/hooks/api/useProject';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { ProjectAnchorNavigate as Navigation } from '../components/ProjectAnchorNavigate';
import { InPartCompetition } from '../components/InPartCompetition';
import { ButtonsWrapper } from '../styles';
import { useSelector } from 'react-redux';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import tinycolor from 'tinycolor2';
import { useHistory } from 'react-router-dom';

const Wrap = styled(FlexBox)<{ visible?: boolean, isPreview?: boolean, disableOffset?: boolean }>`
    width: 100%;
    display: ${({ visible }) => visible ? 'flex' : 'none'};
    max-width: 1152px;
    margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '32px auto 16px auto'};
    flex-flow: column;
    background-color: transparent;

    //padding: 0 6px 0 48px;

    ${({ isPreview }) => isPreview ? css`
        .approval-dialog-wrap {
            display: none;
        }
    ` : null};

    #tags_container {
        width: 100%;
        max-width: 1152px !important;
    }

    .ps-bottom-wrap {
        flex-flow: column;
        align-items: flex-start;
    }

    div:has(.competition-send) {
        margin-bottom: 0;
    }

    .buttons-wrapper > div {
        &:not(:last-child) {
            margin-right: 16px;
            margin-bottom: 16px !important;
        }
        margin-bottom: 16px !important;
        // svg path {
        //   fill: rgba(0,0,0,0.47);
        // }
        padding: 0;
        order: 0;
      
        @media(max-width: ${LayoutConst.screen.s -1 }px) {
            &:not(:last-child) {
                margin-right: 8px;
            }
        }
      }
    
      .LikesButtonWrapper, .ViewsCountWrapper {
        max-width: fit-content !important;
      }
    
      .likes-icon-wrapper {
        flex-direction: row !important;
        place-items: center;
        display: flex;
    
        @media(max-width: ${LayoutConst.screen.sm}px) {
            flex-direction: column !important;
            // padding-top: 8px;
        }
      }
    
      .likes-icon-wrapper > span {
        margin-left: 8px;
        font-size: 11px;
        line-height: 11px;
        margin-top: 4px;
        // color: rgba(0,0,0,0.47);
    
        @media(max-width: ${LayoutConst.screen.sm}px) {
          margin: 0;
          margin-top: 4px;
        }
      }
    
      .count-icon-wrapper {
        place-items: center;
        display: flex;
        flex-direction: row !important;
        @media(max-width: ${LayoutConst.screen.sm}px) {
            flex-direction: column !important;
            // padding-top: 8px;
        }
      }

    //   .project-tools-send svg path {
    //     fill: rgba(0,0,0,0.47) !important;
    //   }

    //   .project-tools-send svg:hover path {
    //     fill: ${Colors.galBlack100} !important;
    //   } 
    
      .count-icon-wrapper span {
        margin-left: 8px;
        line-height: 11px;
        margin-top: 4px;
        // color: rgba(0,0,0,0.47);
        @media(max-width: ${LayoutConst.screen.sm}px) {
            margin: 0;
            margin-top: 4px;
        }
      }
    
      .ps-action-btn {
        padding: 0 !important;
      }
      .ps-action-moder-btn {
        padding: 0;
      }


      .approval-dialog-wrap {
        margin-left: 0;
        margin-top: 40px;
        max-width: 100%;
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        //padding: 0 36px;
        max-width: 888px;

        .approval-dialog-wrap {
            margin-left: 0;
            margin-top: 40px;
            max-width: 432px;
        }
      }

      @media(max-width: ${LayoutConst.screen.l}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '48px auto 0'};
        padding-bottom: 8px;
      }

      @media(max-width: ${LayoutConst.screen.md}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '32px auto 0 auto'};
        padding: 0 24px 16px;
      }

      @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: ${({ disableOffset }) => disableOffset ? '0 0 0 0' : '24px auto 0'};
        padding: 0 10px;

        .ps-action-btn {
            margin-left: 0 !important;
        }

        .likes-icon-wrapper {
            padding-bottom: 0px;
            column-gap: 4px;
            flex-direction: row !important;
            place-items: center;
        }

        .likes-count-text {
            margin-left: 0 !important;
        }

        .ViewsCountWrapper {
            padding-top: 0px !important;
        }

        .count-icon-wrapper {
            column-gap: 4px;
            flex-direction: row !important;
        }

        .view-count-text {
            margin-left: 0 !important;
        }

        .curators-item {
            // margin-left: 8px;
            margin-right: 0 !important;
        }

        .competition-send {
            margin-right: 0;
            margin-left: 0;
        }

        .approval-dialog-wrap {
            margin-top: 24px;
        }

        .buttons-wrapper {
            flex-direction: row;

            .ps-action-btn , .ps-action-moder-btn{
                margin-right: 8px;
            }

            .likes-icon-wrapper {
                place-items: center;
            }
        }
      }
    
`;

export const AdditionalTitle = styled.div<{color?: string, isMobile?: boolean, mobileColor?: string}>`
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    color: ${({ theme, color, isMobile }) => (color && !isMobile) ? color : theme.projectView.lGTitleColorMobile};
    margin-bottom: 8px;


    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 34px;
    line-height: 41px;
    }
    
    @media ${MEDIA.MOBILE} {
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 4px;
    ${({mobileColor}) => mobileColor && `color: ${mobileColor};`}
    }
`;

export const AdditionalSubtitle = styled.div<{color?: string, isMobile?: boolean, mobileColor?: string}>`

    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    color: ${({ theme, color, isMobile }) => (color && !isMobile) ? color : theme.projectView.lGTitleColorMobile};
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }
    
    @media ${MEDIA.MOBILE} {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 40px;
        ${({mobileColor}) => mobileColor && `color: ${mobileColor};`}
    }
`;


export const AdditionalButton = styled(FlexBox)<{ color?: string, bgColor?: string }>`
    border-radius: 3px;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: ${({ theme, color }) => color || theme.projectView.titleColor};
    background-color: ${({ bgColor }) => bgColor};
    min-width: 187px;
    padding: 12px 48px;
    width: max-content;
    justify-content: center;

    a {
        text-align: center;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        margin-bottom: 24px;
        height: 40px;
        align-items: center;
    }

`;

const TagsWrapper = styled(FlexBox)<{ isAdditionalContent?: boolean }>`

    ${({ isAdditionalContent }) => isAdditionalContent && css`
        margin-top: 56px;
    `};
    margin-bottom: 32px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-bottom: 48px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: 24px;
    }
`;

const TitleWrapper = styled(FlexBox)<{ hseFonts?: boolean }>`
    font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
    font-weight: ${({ hseFonts }) => hseFonts ? 400 : 600};
    
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-bottom: 24px;

    }
`;

const HeaderWrapper = styled(FlexBox)`
    .ProjectHeaderRoot {
        padding-left: 0;
    }
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        .ProjectHeaderRoot {
            margin-bottom: 12px;
        }
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        .ProjectHeaderRoot {
            margin-bottom: 8px;
        }
    }
`;

const TagsList = styled(BTagsGrid)<{ isWideEditor?: boolean }>`

    max-height: ${p => p.scroll ? '92px' : 'none'} !important;
  
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-height: ${p => p.scroll ? (p.isWideEditor ? '81px' : '83px') : 'none'} !important;
    }

    @media(max-width: 940px) {
        max-height: ${p => p.scroll ? '72px' : 'none'} !important;
    }

    @media(max-width: 743px) {
        max-height: ${p => p.scroll ? '115px' : 'none'} !important;
    }

`;

const Wrapper = styled.div`
    width: 100%;
    padding-bottom: 40px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 24px;

    @media ${MEDIA.LAPTOP}
        gap: 0 24px;
    }
  
    @media ${MEDIA.MOBILE} {
        grid-template-columns: repeat(1, 1fr);
        gap: 0 0;
    }
`;

const AnchorText = styled.div`
    font-family: Inter;
    letter-spacing: -0.4px;
    margin-right: 8px;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

const AnchorContainer = styled<any>(FlexBox)`
    width: 100%;
    justify-content: space-between;
    place-items: center;
    border-top: 1px solid ${(p) => (p?.color)};
    padding: 16px 0;
    cursor: pointer;

    &:nth-last-child(-n + 2) {
        border-bottom: 1px solid ${(p) => (p?.color)};
    }

    @media ${MEDIA.MOBILE} {
        &:nth-last-child(-n + 2) {
            border-bottom: none;
        }

        &:last-child {
            border-bottom: 1px solid ${(p) => (p?.color)};
        }
    }

    ${AnchorText} {
        color: ${(p) => (p?.color)};
    }

    svg path {
        fill: ${(p) => (p?.color)};
    }
`;


interface IPresentationBlock {
    project?: Project;
    anchors?: any[];
    title?: ReactElement;
    bottom?: ReactElement;
    mobileBottom?: ReactElement;
    tags?: ReactElement[] | ReactElement;
    dialog?: ReactElement;
    isPreview?: boolean;
    isOutsideText?: boolean;
    titleColor?: string;
    subtitleColor?: string;
    additionalContent?: IAddProjectCoverContent;
    isModer?: boolean;
    competitionsParticipant?: Competition[];
    competitionsWinner?: Competition[];
    competitionFynalist?: Competition[];
}

export const PSpresentationBlock: FC<IPresentationBlock> = ({ 
    project,
    anchors, 
    title, 
    tags, 
    bottom, 
    mobileBottom, 
    dialog, 
    isPreview, 
    isOutsideText,
    subtitleColor, 
    titleColor,
    isModer,
    competitionsParticipant = [],
    competitionsWinner = [],
    competitionFynalist = []
}) => {
    const profile = useProfile();
    const { t, i18n: {language}} = useTranslation();
    const [collapseTags, setCollapseTags] = useState(false);
    const isTeam = useMemo(() => (project && !!project?.teamId), [project]);
    const isTablet = useBreakpoint(LayoutConst.screen.l)
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isProHSE = AppTester.isProHSE();
    const history = useHistory()
    const [time, setTime] = useState(Date.now());
    //@ts-ignore
    const [projectSource, isProjectLoading, projectError] = useProject(project?.replaceLongreadId, language, project?.replaceLongreadId + time);
    //@ts-ignore
    const isTeamHasLongreadCover = !!project?.longreadType
    //@ts-ignore
    const additionalContent = useMemo(() => isTeamHasLongreadCover ? projectSource?.additionalContent : project?.additionalContent , [project, isProjectLoading, projectSource]) as IAddProjectCoverContent | undefined

    const theme = useTheme()
    const { anchorLinks } = useSelector(HseContextSelector) || {};
    const visibleTextColor = tinycolor.mostReadable(theme?.app?.backgroundColor, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
    
    const teamLgTitleVisibleColor = tinycolor.mostReadable(project?.additionalInfo.color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
    
    // @ts-ignore
    const isLMS = useMemo(() => project?.moderationType === ModerationType.LMS, [project?.moderationType])

    // const maxTagHeight = (isMac13 || smHeight) ? 94 : 94;
    const maxTagHeight = isProHSE ? 96 : 94;

    useEffect(() => {
        const tagsContainer: HTMLElement | null = document.querySelector('#tags_container');
        if (tagsContainer) {
          if (tagsContainer?.offsetHeight > maxTagHeight) {
            setCollapseTags(true);
          }
        }
    }, [maxTagHeight])

    const hasAdditionalContent = useMemo(
        //@ts-ignore
        () => additionalContent && Object.values(additionalContent)?.some((i) => i?.text !== ''), [additionalContent]);

    const navgationVisible = useMemo(() => {
        if (additionalContent) {
            const content = additionalContent as IAddProjectCoverContent
            return !!content?.anchors?.anchorVisible && content?.anchors?.anchorType === ANCHOR_TYPE.popup
        }
        return undefined
    }, [project, hasAdditionalContent])

    const Layout = useMemo(() => {

        // if (!isOutsideText) return null;

        if (!!hasAdditionalContent) {
            const { title, subtitle, button, anchors } = additionalContent;

            return (
                <FlexBox style={{ position: 'relative' }} direction='column' directionMobile='column'>
                    {title.visible && (isOutsideText || is743) && (
                        <FlexBox direction='column' directionMobile='column'>
                            <AdditionalTitle mobileColor={isTeam? teamLgTitleVisibleColor : undefined} color={titleColor} isMobile={is743}>{Lang(title.text, language)}</AdditionalTitle>
                            {!!Lang(subtitle.text, language)?.length && <AdditionalSubtitle mobileColor={isTeam? teamLgTitleVisibleColor : undefined} color={subtitleColor} isMobile={is743}>{Lang(subtitle.text, language)}</AdditionalSubtitle>}
                        </FlexBox>
                    )}
                    {is743 && !!anchorLinks?.length && <Wrapper>
                        <Grid>
                            {anchorLinks?.map(({anchorText, postId}) => {
                                return (
                                    <AnchorContainer key={`anchor ${postId}`} color={visibleTextColor} onClick={() => history.push(`#${postId}`)}>
                                        <AnchorText>{anchorText}</AnchorText>
                                        <div>
                                            <svg
                                                width='13'
                                                height='23'
                                                viewBox="0 0 13 23"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.5 0V15.75H10.1895L6.69653 12.2571C6.40386 11.9642 6.40371 11.4894 6.69653 11.1965C6.98935 10.9037 7.46417 10.9039 7.75708 11.1965L12.5303 15.9697C12.8232 16.2626 12.8232 16.7374 12.5303 17.0303L7.75708 21.8035C7.46417 22.0961 6.98935 22.0963 6.69653 21.8035C6.40371 21.5106 6.40386 21.0358 6.69653 20.7429L10.1895 17.25H0V0H1.5Z"
                                                    fill="#151514"
                                                />
                                            </svg>
                                        </div>
                                    </AnchorContainer>
                                )
                            })}
                        </Grid>
                    </Wrapper>}
                    {button?.visible && (isOutsideText || is743) && (
                        <a href={button.href} target={'_SELF'}>
                            <AdditionalButton color={button.color} bgColor={button.bgColor}>{Lang(button.text, language)}</AdditionalButton>
                        </a>
                    )}

                    {tags && (Array.isArray(tags)? tags.length > 0 : true) && !isLMS && (
                        <TagsWrapper width={'100%'} isAdditionalContent={((title.visible && !!Lang(subtitle.text, language)?.length) || button.visible) && isOutsideText}>
                            <BTagsGridNew id="tags_container" scrollMode="all">
                                {tags}
                            </BTagsGridNew>
                        </TagsWrapper>
                    )}
                    {bottom && !is743 && (
                        <FlexBox>
                           {/* {navgationVisible && <Navigation anchors={anchors} />} */}
                            {bottom}
                        </FlexBox>
                    )}
                    {is743 && mobileBottom && (
                        <FlexBox offsetBottomMobile={!profile ? 0 : isModer? 48 : 14}>
                            {mobileBottom}
                        </FlexBox>
                    )}
                    {dialog && (
                        <FlexBox width={'100%'}>
                            {dialog}
                        </FlexBox>
                    )}
                </FlexBox>
            )

        } else {
            return (
                <>
                    {title && (
                        <TitleWrapper>
                            {title}
                        </TitleWrapper>
                    )}
                    {tags && !isLMS && (
                        <TagsWrapper width={'100%'}>
                            <BTagsGridNew id="tags_container" scrollMode="all">
                                {tags}
                            </BTagsGridNew>
                        </TagsWrapper>
                    )}
                    {bottom && !is743 && (
                        <FlexBox width={'100%'} offsetBottom={isTablet? 0 : 48} offsetBottomMobile={isTablet? 0 : 48}>
                            {bottom}
                        </FlexBox>
                    )}
                    {is743 && (!!mobileBottom || !!anchorLinks?.length) && (
                        <FlexBox offsetBottomMobile={!profile ? 0 : 48}>
                            <Wrapper>
                                <Grid>
                                    {anchorLinks?.map(({anchorTest: text, postId: id}) => {
                                        return (
                                            <AnchorContainer key={`anchor ${id}`} color={visibleTextColor} onClick={() => history.push(`#${id}`)}>
                                                <AnchorText>{text}</AnchorText>
                                                <div>
                                                    <svg
                                                        width='13'
                                                        height='23'
                                                        viewBox="0 0 13 23"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M1.5 0V15.75H10.1895L6.69653 12.2571C6.40386 11.9642 6.40371 11.4894 6.69653 11.1965C6.98935 10.9037 7.46417 10.9039 7.75708 11.1965L12.5303 15.9697C12.8232 16.2626 12.8232 16.7374 12.5303 17.0303L7.75708 21.8035C7.46417 22.0961 6.98935 22.0963 6.69653 21.8035C6.40371 21.5106 6.40386 21.0358 6.69653 20.7429L10.1895 17.25H0V0H1.5Z"
                                                            fill="#151514"
                                                        />
                                                    </svg>
                                                </div>
                                            </AnchorContainer>
                                        )
                                    })}
                                </Grid>
                            </Wrapper>
                            {mobileBottom}
                        </FlexBox>
                    )}
                    {dialog && (
                        <FlexBox width={'100%'}>
                            {dialog}
                        </FlexBox>
                    )}
                </>
            )
        }

    } , [hasAdditionalContent, anchors, is743, additionalContent, language, bottom, dialog, collapseTags, is743,  isProHSE, isTablet, title, mobileBottom, profile, isOutsideText, tags])

    const disableOffset = useMemo(() => {
        const hasTitle  = !!hasAdditionalContent && Lang(additionalContent?.title.text, language)?.length > 0
        const hasSubtitle = !!hasAdditionalContent && Lang(additionalContent?.subtitle.text, language)?.length > 0
        const textVisible = (hasTitle || hasSubtitle) && (isOutsideText || is743)

        return !mobileBottom && !dialog && !bottom && (!!tags && isLMS) && !title && !textVisible 
    } , [mobileBottom, dialog, bottom, tags, title, additionalContent, isOutsideText])

    if (!project) {
        return null;
    }

    return (
        isLMS ? (
            <Wrap disableOffset={disableOffset} visible={true} isPreview={isPreview}>
                {Layout}
            </Wrap>
        ) : (
            <Wrap disableOffset={disableOffset} visible={!isTeam || (isTeam && is743)} isPreview={isPreview}>
                <HeaderWrapper>
                    {isTeam ? (
                        //@ts-ignore
                        <>{is743? undefined : <TeamHeader team={project} />}</>
                    ) : (
                        <ProjectHeader project={project} isProjectPage={true} />
                    )}
                </HeaderWrapper>
                {Layout}
                <InPartCompetition
                  competitionsParticipant={competitionsParticipant}
                  competitionsWinner={competitionsWinner}
                  competitionFynalist={competitionFynalist}
                  isMaxWidth
                />
            </Wrap>
        )
    );
}